import { jsx } from "react/jsx-runtime";
import { IconButton } from "../IconButton/index.js";
const CarouselAutoplayButton = ({ onClick, autoplayIsPlaying, iconButtonProps = {}, disabled = false, autoplayButtonClasses = '', ...props })=>{
    const { iconName = autoplayIsPlaying ? 'pause' : 'play_arrow', size = '3xs', ...restProps } = iconButtonProps;
    const handleClick = (event)=>{
        event.stopPropagation();
        onClick();
    };
    const ariaLabel = autoplayIsPlaying ? 'Pause autoplay' : 'Play autoplay';
    return /*#__PURE__*/ jsx("div", {
        className: autoplayButtonClasses,
        ...props,
        children: /*#__PURE__*/ jsx(IconButton, {
            "data-testid": "carousel-autoplay-button",
            type: "plainPrimary",
            emphasis: "bold",
            size: size,
            disabled: disabled,
            iconName: iconName,
            onClick: handleClick,
            "aria-label": ariaLabel,
            ...restProps
        })
    });
};
export { CarouselAutoplayButton };
